// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"3":"78ae9be2","52":"927f3d46","64":"eedfc337","193":"762d21c2","240":"1a94b8d5","281":"16973625","515":"14c45d95","619":"dc1e1d08","633":"7e64afd4","643":"a482de54","710":"3015e96d","823":"1c785834","829":"749b2f19","899":"67eb3cc2","974":"6436a458"}[chunkId] + ".js";
};